import script from "./ControllerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ControllerCard.vue?vue&type=script&setup=true&lang=js"

import "./ControllerCard.vue?vue&type=style&index=0&id=33e833af&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e833af"]])

export default __exports__